import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { AutoComplete, Input, message, Button, Popover } from 'antd'
import { MyIcon } from "../../common/baseConfig"
const { Option } = AutoComplete;
class TopSerach extends Component {
  static propTypes = {

  };
  constructor(props) {
    super(props)
    this.state = {
      searchWord: ''
    }
  }
  
  searchCourse() {
    const keyWord = this.state.searchWord;
    if (keyWord.trim() === "") {
      message.warn("搜索关键字不能为空");
      return;
    }
    this.props.history.push(`/search?key=${encodeURI(keyWord)}`);
  }
  onChangeSearch(value) {
    this.setState({
      searchWord: value
    })
  }
  render() {
    const { logUrl } = this.props
    const { fetchGetWeAppCodeSuccess, ActivityData, PublicData } = this.props.common;
    const dataSource = JSON.parse(localStorage.getItem("searchRecord")) || [];
    const renderOption = (item, index) => {
      return (
        <Option key={item}>
          {item}
        </Option>
      );
    }
    const smallProgramCode = (
      <div className="common-top-search-popover-wrap">
        {
          fetchGetWeAppCodeSuccess && <img className="wxImg" src={fetchGetWeAppCodeSuccess.Message} alt="" />
        }
        <p>扫描二维码进入小程序</p>
      </div>
    )
    const publicNumCode = (
      <div className="common-top-search-popover-wrap">
        {PublicData && <img className="wxImg" src={PublicData.Url} alt="" />}
        <p>扫描二维码关注公众号</p>
      </div>
    )
    return (
      <div className="common-top-search">
        <div className="common-top-wrap">
          <div className="common-top-search-logo">
            <img alt="" src={logUrl || ''} style={{ height: '46px', }} />
          </div>
          <div className="common-top-search-input">
            <AutoComplete
              className="search_input"
              dropdownClassName="search_input_dropdown"
              dropdownMatchSelectWidth={false}
              dropdownStyle={{ width: 455 }}
              size="large"
              style={{ width: '100%' }}
              dataSource={dataSource.map(renderOption)}
              onChange={this.onChangeSearch.bind(this)}
              placeholder="输入搜索内容"
            >
              <Input suffix={<Button
                className="search-btn"
                style={{ marginRight: -12 }}
                size="large"
                onClick={() => this.searchCourse()}
                type="theme"
              >
                <MyIcon type="iconsousuo" className="search-icon" />
              </Button>} />
            </AutoComplete>
          </div>
          <div className="common-top-search-menus">
            {ActivityData && ActivityData.Valid === 1 && <div className="common-top-search-menu" onClick={() => {
              window.open(ActivityData.Url);
            }}>
              <MyIcon type="iconhuodong" className="menu-icon" />
              <p>活动</p>
            </div>}
            {PublicData && PublicData.Valid === 1 && <Popover className="common-top-search-menu" trigger="hover" placement="bottom" content={publicNumCode}>
              <MyIcon type="icongongzhonghao" className="menu-icon" />
              <p>公众号</p>
            </Popover>}
            {fetchGetWeAppCodeSuccess && !fetchGetWeAppCodeSuccess.Data && <Popover className="common-top-search-menu" trigger="hover" placement="bottom" content={smallProgramCode}>
              <MyIcon type="iconxiaochengxu " className="menu-icon" />
              <p>小程序</p>
            </Popover>}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(TopSerach)


// WEBPACK FOOTER //
// ./src/features/common/TopSerach.js